import TailwindButton from "components/general/tailwindButton";
import SvgIcon from "components/general/svgIcon";
import { downloadLinksArray } from "data/variables";

const FooterPersonalPrice = () => {
  return (
    <>
      <div className="flex w-full items-end justify-center sm:-mt-10 mt-10 ">
        <div className="flex w-[350px] h-[290px] sm:w-[1028px] sm:h-[192px] items-end justify-center sm:mt-20 bg-gradient-to-r from-brand-purple to-brand-blue rounded-xl">
          <div className="flex flex-col sm:flex-row w-[346px] h-[286px] sm:w-[1024px] sm:h-[188px] sm:items-end bg-clip-border rounded-xl bg-brand-slate mb-[2px]">
            <div className="flex w-full items-end justify-start bg-brand-slate h-full rounded-xl">
              <div className="flex sm:flex-row flex-col mb-3 ml-6">
                <div className="flex flex-col  text-center sm:mb-5 sm:ml-16">
                  <p className="font-bold text-3xl sm:text-5xl">Connect. Manage.</p>
                  <p className="font-bold text-3xl sm:text-5xl bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text mt-0">
                    Redact.
                  </p>
                </div>

                <div className="flex flex-col justify-end items-center sm:mb-3 sm:ml-56">
                  <TailwindButton
                    buttonBGColor="bg-[#25262D]"
                    buttonHeight="h-[45px]"
                    buttonWidth="w-[174px]"
                    buttonBorderColor="border-[#422686]"
                    buttonText="Create account!"
                    buttonURL="/account"
                    buttonTextTailwindStyle="font-bold"
                  />

                  <div className="flex flex-row ml-[2rem]">
                    {downloadLinksArray.map((value) => {
                      return (
                        <a
                          className="mt-[1.5rem] h-[2rem] fill-white text-white hero__button_row__icon"
                          href={value.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          key={"" + value.icon + value.link}
                        >
                          <SvgIcon name={value.icon} />
                        </a>
                      );
                    })}
                  </div>

                  <p className="font-thin text-sm">Available on windows, MacOS, and Linux Today</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-28" />
    </>
  );
};

export default FooterPersonalPrice;
